import { TherapistCertificationResponseModel } from './therapist-certification-response-model';
export class TherapistDeviceInfoModel {
  appUserInfoId: string;
  modifiedByUserInfoId: number;
  therapistCertification: TherapistCertificationResponseModel[];
}
